import { Field } from 'formik';
import React from 'react';
import { CustomAutoCompleteField } from './CustomAutoCompleteField';
export var CustomAutoCompleteFieldContainer = function (props) {
    return (React.createElement(Field, { component: CustomAutoCompleteField, onHandleChange: function (data) {
            props.onHandleChange && props.onHandleChange(data);
        }, half: props.half, options: props.options, disabledValues: props.disabledValues && props.disabledValues, name: props.name, label: props.label, placeholder: props.placeholder, disabled: props.disabled }));
};
CustomAutoCompleteFieldContainer.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CustomAutoCompleteFieldContainer.js.map